/*
 * @Author: zgz
 * @Date: 2021-01-18 20:08:43
 * @LastEditors: zgz
 * @LastEditTime: 2021-04-28 16:53:33
 * @Description:
 */
import Vue from 'vue'
import Router from 'vue-router'

// 消除重复replace同一URL出现的异常
const originalPush = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      redirect: {
        name: 'init'
      },
    },
    // {
    //   path: '/testGame',
    //   name: 'testGame',
    //   component: () =>
    //     import("../components/testGame/index.vue")
    // },
    {
      path: '/init',
      name: 'init',
      component: () =>
        import("../components/init/index.vue")
    },
    {
      path: '/autoLogin',
      name: 'autoLogin',
      component: () =>
        import("../components/autoLogin/index.vue")
    },
    {
      path: '/login',
      name: 'login',
      component: () =>
        import("../components/login/index.vue")
    },
    {
      path: '/quickLogin',
      name: 'quickLogin',
      component: () =>
        import("../components/quickLogin/index.vue")
    },
    {
      path: '/forgetPwd',
      name: 'forgetPwd',
      component: () =>
        import("../components/forgetPwd/index.vue")
    },
    {
      path: '/phoneLogin',
      name: 'phoneLogin',
      component: () =>
        import("../components/phoneLogin/index.vue")
    },
    {
      path: '/pay',
      name: 'pay',
      component: () =>
        import("../components/pay/index.vue")
    },
    {
      path: '/realname',
      name: 'realname',
      component: () =>
        import("../components/realname/index.vue")
    },
    {
      path: '/realnameLoading',
      name: 'realnameLoading',
      component: () =>
        import("../components/realnameLoading/index.vue")
    },
    {
      path: '/foreignRealName',
      name: 'foreignRealName',
      component: () =>
        import("../components/foreignRealName/index.vue")
    },
    {
      path: '/foreignSuccess',
      name: 'foreignSuccess',
      component: () =>
        import("../components/foreignSuccess/index.vue")
    },
    {
      path: '/redEnvelope',
      name: 'redEnvelope',
      component: () =>
        import("../components/redEnvelope/index.vue")
    },
    {
      path: '/iframe',
      name: 'iframe',
      component: () =>
        import("../components/iframe/index.vue")
    },
    {
      path: '/error',
      name: 'error',
      component: () =>
        import("../components/error/index.vue")
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js